var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pg-progress"},[_c('div',{staticClass:"pg-progress-inner",style:({ width: _vm.lineWidth })}),_c('div',{staticClass:"progress-text"},[_vm._v(" "+_vm._s(_vm.current)+"/"+_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }